import Banner from '@/components/UI/Banner';
import Button from '@/components/UI/Button';
import { ApiService } from '@/support/ApiService';
import { type FC, useState } from 'react';
import type { MainUser } from '@/model/User.model';

interface RevokeInvitationProps {
  users: Array<MainUser>;
  handleCallback: (message: string) => void;
  closeModal: () => void;
}

const RevokeInvitation: FC<RevokeInvitationProps> = ({ users, handleCallback, closeModal }) => {
  const [loading, setLoading] = useState(false);
  const [apiError, setAPIerror] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const promises = users.map((user) => {
        return ApiService.call({
          endpoint: 'DELETE /api/v1/users/{userId}/revoke-invitation',
          path: { userId: String(user.id) },
        });
      });

      await Promise.all(promises);
      closeModal();
      handleCallback(`Successfully revoked ${users.length} invitation${users.length > 1 ? 's' : ''}`);
    } catch {
      setLoading(false);
      setAPIerror(true);
    }
  };

  const text = {
    title: 'Revoke',
    desc: 'Data captured will remain intact and will not be deleted.',
    btnLoading: 'Revoking',
  };

  return (
    <form onSubmit={handleSubmit} className="ui__narrow-modal">
      <div className="pb3 tc">
        <h3 className="normal f4 pb2">
          {text.title} invitation{users.length > 1 ? 's' : ''}
        </h3>
        <p className="f6 pb2">{text.desc}</p>
        {apiError && (
          <Banner critical dismiss={false} className="mw6 mt3">
            <h3 className="f5 normal lh-title pb2">There was an error with your submission</h3>
            <p className="f6 pb3 lh-copy">
              An error has occurred when submitting the form, please try again later. If this keeps occurring please
              contact support.
            </p>
            <Button outline critical url={'mailto:support@benchling.com'}>
              Contact support
            </Button>
          </Banner>
        )}
      </div>
      <div>
        <Button disabled={loading} submit className="w-100 mb2">
          {!loading ? text.title : `${text.btnLoading}...`}
        </Button>
        <Button plain onClick={closeModal} className="w-100">
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default RevokeInvitation;
